import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectElearningData } from 'store/elearning.slice';
import { MdArrowBack } from 'react-icons/md';
import { PATH } from 'constants/path';

const NAVIGABLE_TYPES = ['book', 'page', 'quiz', 'supervideo', 'forum'];

function getModuleRoute(mod, courseId) {
  switch (mod.modname) {
    case 'book':
      return `${PATH.ELEARNING.STUDENT.BOOK.replace(':id', mod.instance)}?m=${mod.id}&i=${mod.instance}&urls=${
        mod.contents?.filter((c) => c.filename === 'index.html').map((c) => c.fileurl).join(',')
      }`;
    case 'page':
      return `${PATH.ELEARNING.STUDENT.BOOK.replace(':id', mod.instance)}?m=${mod.id}&url=${mod.contents?.[0]?.fileurl}`;
    case 'quiz':
      return `${PATH.ELEARNING.STUDENT.TEST_DETAIL.replace(':id', mod.instance)}?m=${mod.id}&c=${courseId}`;
    case 'supervideo':
      return `${PATH.ELEARNING.STUDENT.VIDEO.replace(':id', mod.instance)}?m=${mod.id}`;
    case 'forum':
      return `${PATH.ELEARNING.STUDENT.FORUM.replace(':id', mod.instance)}?m=${mod.id}`;
    default:
      return null;
  }
}

function BackButton({ confirmMessage }) {
  const navigate = useNavigate();
  const { courseContents } = useSelector(selectElearningData);
  const currentModuleId = Number(new URLSearchParams(window.location.search).get('m'));

  const { nextModule, courseId } = useMemo(() => {
    if (!courseContents || !currentModuleId) return {};

    for (const cId of Object.keys(courseContents)) {
      const sections = courseContents[cId];
      if (!Array.isArray(sections)) continue;

      const allModules = sections.flatMap((s) => s.modules || []);
      const currentIndex = allModules.findIndex((m) => m.id === currentModuleId);
      if (currentIndex === -1) continue;

      for (let i = currentIndex + 1; i < allModules.length; i++) {
        if (NAVIGABLE_TYPES.includes(allModules[i].modname)) {
          return { nextModule: allModules[i], courseId: cId };
        }
      }
      return { nextModule: null, courseId: cId };
    }
    return {};
  }, [courseContents, currentModuleId]);

  const handleNext = () => {
    if (!nextModule) return;
    if (confirmMessage && !window.confirm(confirmMessage)) return;
    const route = getModuleRoute(nextModule, courseId);
    if (route) navigate(route);
  };

  return (
    <div
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(6px)',
        padding: '8px 12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: 12,
      }}
    >
      <button
        onClick={() => {
          if (confirmMessage && !window.confirm(confirmMessage)) return;
          window.history.back();
        }}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          padding: '6px 14px 6px 10px',
          border: 'none',
          background: 'none',
          color: '#4b5563',
          fontSize: '0.9rem',
          fontWeight: 500,
          borderRadius: 8,
          cursor: 'pointer',
          transition: 'background 0.15s, color 0.15s',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#f3f4f6';
          e.currentTarget.style.color = '#111827';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'none';
          e.currentTarget.style.color = '#4b5563';
        }}
      >
        <MdArrowBack size={18} />
        <span>Quay lại</span>
      </button>

      {nextModule && (
        <button
          onClick={handleNext}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            padding: '6px 10px 6px 14px',
            border: 'none',
            background: 'none',
            color: '#2563eb',
            fontSize: '0.85rem',
            fontWeight: 500,
            borderRadius: 8,
            cursor: 'pointer',
            maxWidth: '60%',
            transition: 'background 0.15s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#eff6ff';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'none';
          }}
        >
          <span style={{ fontSize: '0.8rem', color: '#6b7280', flexShrink: 0 }}>Tiếp theo:</span>
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {nextModule.name}
          </span>
        </button>
      )}
    </div>
  );
}

export default BackButton;
